export default __webpack_public_path__ + "static/cta-button-487f725c7d7d0729437bd09dc6f9b120.svg";